import Swiper, {
    Navigation
} from 'swiper';
import {clearFeedbacksByName, clearInputsByName, getInputsByName} from "../helpers/forms";
import {loading, stopLoading} from "../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../helpers/handleAjaxError";
import Swal from "sweetalert2";

Swiper.use([Navigation]);

let swiper = null;
const contactFormFields = [
    'name',
    'email',
    'message',
    'g_captcha'
];

function initHome() {
    swiper = new Swiper('.swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,

        slidesPerView: 1,
        spaceBetween: 0,

        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            }
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        on: {
            init: () => {
                document.querySelectorAll('.fade-wall-right,.fade-wall-left').forEach(wallElement => {
                    wallElement.classList.remove('d-none');
                });
            }
        }
    })

    document.querySelector('.submit-contact-form').onclick = submitContactForm;
}

function submitContactForm() {
    const contactFormContainer = document.querySelector('.contact-form .container');
    const data = getInputsByName(contactFormContainer, contactFormFields);
    data.g_captcha = window.grecaptcha.getResponse();

    clearFeedbacksByName(contactFormContainer, contactFormFields);

    loading(contactFormContainer);
    Axios.post('/contact-form', data)
        .then(response => {
            Swal.fire({
                icon: 'success',
                title: response.data.title,
                text: response.data.message,
                timer: 2000
            })
            clearInputsByName(contactFormContainer, contactFormFields);
            window.grecaptcha.reset();
        })
        .catch(error => {
            // Only display first error otherwise the form overflows
            const firstErrorName = Object.keys(error.response.data.errors)[0];
            error.response.data.errors = {
                [firstErrorName]: error.response.data.errors[firstErrorName]
            };
            handleAjaxError(error);
        })
        .finally(() => stopLoading(contactFormContainer));
}

export {
    initHome
}